import { DocumentNode, gql } from '@apollo/client';
import {
  BoxProps,
  Button,
  HStack,
  LinkBox,
  LinkOverlay,
  Spacer,
  Text,
  VStack,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { getAppropriateEventLink } from '@/hooks/getAppropriateEventLink';
import { usePostHref } from '@/hooks/usePostHref';
import { CalendarIcon } from '@/imports/ui/chakra/feather';

import { EventAlertAnnouncement_EventAlertFragment } from './graphql-types/EventAlertAnnouncement_EventAlertFragment';

import { Card } from '../Card';

const POST_FRAGMENT = gql`
  fragment EventAlertAnnouncement_EventAlertFragment on EventAlert {
    _id
    event {
      _id
      ...GetAppropriateEventLink_EventFragment
    }
  }
  ${getAppropriateEventLink.eventFragment}
`;

export const EventAlert: React.FC<
  {
    eventAlert: EventAlertAnnouncement_EventAlertFragment;
  } & BoxProps
> & { eventAlertFragment: DocumentNode } = ({
  eventAlert,
  children,
  ...boxProps
}) => {
  const postHref = usePostHref(eventAlert._id);
  const eventLink = getAppropriateEventLink(eventAlert.event ?? undefined);

  return (
    <LinkBox>
      <Card {...boxProps}>
        <VStack overflow="hidden" alignItems="start" spacing="0">
          <HStack>
            <CalendarIcon color="gray.500" />
            <Text textStyle="detail" color="gray.500" fontWeight="600">
              <LinkOverlay as={NextLink} href={postHref}>
                EVENT
              </LinkOverlay>
            </Text>
          </HStack>
          {/* TODO event alert */}
          <Spacer />
          <NextLink href={eventLink}>
            <Button w="full" size="sm">
              Register
            </Button>
          </NextLink>
        </VStack>
      </Card>
      {children}
    </LinkBox>
  );
};
EventAlert.eventAlertFragment = POST_FRAGMENT;
